angular.module('unica_feedback_category.feedback_category_services')

.factory('FeedbackCategoryListService', function ($http, getBaseApiURL) {

	var feedbackCategoryListService = {};


	feedbackCategoryListService.list = function (eventId, limit, offset)
	{
		return $http({
			method: 'POST',
			url: getBaseApiURL + '/feedback-category/list/' + eventId,
			data: {
				limit: limit,
				offset: offset
			}
		}).then(function(result) {

			if ( result ) {
				return result.data.feedback_categories;
			}

		});

	};

	feedbackCategoryListService.fullList = function (eventId)
	{
		return $http({
			method: 'POST',
			url: getBaseApiURL + '/feedback-category/full-list/' + eventId,
			data: { }
		}).then(function(result) {

			if ( result ) {
				return result.data.feedback_categories;
			}

		});

	};

	feedbackCategoryListService.get = function (feedbackCategoryId)
	{
		return $http({
			method: 'POST',
			url: getBaseApiURL + '/feedback-category/detail/' + feedbackCategoryId,
			data: { }
		}).then(function(result) {

			if ( result ) {
				return result.data.category;
			}

		});
	};

	feedbackCategoryListService.exportFeedback = function ( eventId )
	{
		return $http({
			method: 'POST',
			url: getBaseApiURL + '/export/feedback/' + eventId,
			data: { }
		}).then(function(result) {

			if ( result ) {
				return result.data.url;
			}

		});
	};


	return feedbackCategoryListService;
});